export const services = [
  {
    id: 1,
    title: "Trademark Registration",
    description: "Secure exclusive federal rights to your brand name, logo, or slogan through expert USPTO trademark filing.",
    icon: "Shield",
    path: "/services/trademark-registration"
  },
  {
    id: 2,
    title: "Copyright Registration",
    description: "Protect your original creative works, digital content, and intellectual property with official copyright filing.",
    icon: "FileText",
    path: "/services/copyright-registration"
  },
  {
    id: 3,
    title: "Company Formation",
    description: "Launch your business with professional LLC formation, corporation setup, and business registration services.",
    icon: "Building",
    path: "/services/company-formation"
  },
  {
    id: 4,
    title: "Trademark Search",
    description: "Comprehensive USPTO database search and conflict analysis to ensure your mark is available before filing.",
    icon: "Search",
    path: "/services/trademark-search"
  },
  {
    id: 5,
    title: "Amazon Brand Registry",
    description: "Enroll in Amazon Brand Registry with trademark registration support for enhanced seller tools and IP protection.",
    icon: "Package",
    path: "/services/amazon-brand-registry"
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Essentials",
    price: "$45",
    federal: "+ Federal Filing Fee",
    recommended: false,
    features: [
      "Case Review",
      "Case Filing",
      "Basic Search",
      "State E-Filing",
      "Trademark Secured"
    ],
    note: "(Govt. filing fee not included)",
    buttonText: "Get Started Now"
  },
  {
    id: 2,
    name: "Enhanced",
    price: "$149",
    federal: "+ Federal Filing Fee",
    recommended: false,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter"
    ],
    note: "(Govt. filing fee not included)",
    buttonText: "Choose Enhanced"
  },
  {
    id: 3,
    name: "Deluxe",
    price: "$299",
    federal: "+ Federal Filing Fee",
    recommended: true,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager"
    ],
    note: "(Govt. filing fee not included)",
    buttonText: "Choose Deluxe"
  },
  {
    id: 4,
    name: "Platinum",
    price: "$349",
    federal: "+ Federal Filing Fee",
    recommended: false,
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager",
      "High Approval Rate",
      "Comprehensive Search Report",
      "High Priority Service",
      "Cease & Desist Letter"
    ],
    note: "(Govt. filing fee not included)",
    buttonText: "Choose Platinum"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    icon: "Award",
    title: "Proven Track Record",
    description: "Our trademark attorneys have successfully filed thousands of federal trademark applications with the USPTO. We combine deep legal expertise with a streamlined process to deliver results you can count on."
  },
  {
    id: 2,
    icon: "DollarSign",
    title: "Transparent Pricing",
    description: "No hidden costs, no surprise fees. Our trademark registration packages start at $45 with clear pricing for every service level. You know exactly what you're paying for before you commit."
  },
  {
    id: 3,
    icon: "Headphones",
    title: "Dedicated Support",
    description: "Every client gets a dedicated case manager who keeps you informed at every step. From initial trademark search to final USPTO approval, you'll always know where your application stands."
  },
  {
    id: 4,
    icon: "Clock",
    title: "Fast Turnaround",
    description: "We prioritize efficiency without compromising quality. Our streamlined filing process ensures your trademark application is prepared, reviewed, and submitted to the USPTO as quickly as possible."
  }
];

export const workProcess = [
  {
    id: 1,
    step: "01",
    title: "Share Your Brand Details",
    description: "Tell us about your brand, business, and trademark goals. Our team conducts an initial review to understand what you need protected and recommends the best filing strategy for your situation."
  },
  {
    id: 2,
    step: "02",
    title: "Comprehensive Search & Analysis",
    description: "Our experts run a thorough trademark search across USPTO databases, state records, and common law sources. We identify potential conflicts and provide a detailed report with clear recommendations."
  },
  {
    id: 3,
    step: "03",
    title: "File & Monitor Your Application",
    description: "We prepare and submit your trademark application to the USPTO, handle any office actions, and monitor your case through every stage until your trademark registration is secured."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "E-commerce Entrepreneur",
    service: "Trademark Registration",
    content: "Trademark Text Logo handled everything from search to filing. The process was transparent, fast, and completely stress-free. My brand is now federally protected.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Startup Founder",
    service: "Trademark Search",
    content: "The comprehensive trademark search caught a conflict I would have never found on my own. Saved my business from a costly rebrand. Truly professional service.",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer Rodriguez",
    role: "Amazon Seller",
    service: "Amazon Brand Registry",
    content: "Enrolling in Amazon Brand Registry opened up A+ Content and brand protection tools I didn't even know existed. My product listings look amazing now.",
    rating: 5
  },
  {
    id: 4,
    name: "David Thompson",
    role: "Product Designer",
    service: "Copyright Registration",
    content: "Quick, professional copyright registration for my design portfolio. The team kept me updated throughout and explained every step clearly.",
    rating: 5
  },
  {
    id: 5,
    name: "Amanda Stevens",
    role: "Small Business Owner",
    service: "Company Formation",
    content: "Got my LLC formed and trademark filed in one go. The combined package saved me time and money. The team was responsive and knowledgeable.",
    rating: 5
  },
  {
    id: 6,
    name: "Robert Wilson",
    role: "Online Retailer",
    service: "Trademark Registration",
    content: "The Essentials package at $45 was exactly what I needed to get started. No upselling, no pressure. Just solid trademark filing service at a fair price.",
    rating: 5
  },
  {
    id: 7,
    name: "Emily Parker",
    role: "Fashion Brand Owner",
    service: "Trademark Registration",
    content: "The Platinum package gave me complete peace of mind. Monitoring, cease & desist support, and priority service. Worth every dollar for my fashion label.",
    rating: 5
  },
  {
    id: 8,
    name: "James Anderson",
    role: "Tech Startup CEO",
    service: "Company Formation",
    content: "LLC formation and trademark registration were handled simultaneously with perfect coordination. Everything was done faster than I expected. Top-notch service.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is trademark registration and why is it important?",
    answer: "Trademark registration is the legal process of securing exclusive rights to your brand name, logo, or slogan with the USPTO. Federal trademark protection gives you nationwide rights, the ability to use the \u00AE symbol, and is required for Amazon Brand Registry enrollment. Without it, your brand is vulnerable to copycats and unauthorized use."
  },
  {
    id: 2,
    question: "How long does the trademark registration process take?",
    answer: "The complete trademark registration process typically takes 8\u201312 months from filing to final approval. Initial USPTO examination begins within 3\u20134 months. If approved, your mark enters a 30-day opposition period before registration. Our team handles office actions promptly to prevent unnecessary delays."
  },
  {
    id: 3,
    question: "What's included in the $45 Essentials package?",
    answer: "The Essentials package covers case review, USPTO filing, basic trademark search, state e-filing assistance, and trademark securing. It's ideal for straightforward marks with low conflict risk. Federal filing fees ($250\u2013$350 per class) are paid directly to the USPTO and are not included."
  },
  {
    id: 4,
    question: "How are the pricing packages different?",
    answer: "Essentials ($45) covers basic filing. Enhanced ($149) adds direct hit search, risk assessment, and trademark alerts. Deluxe ($299) includes monitoring, complete documentation, and a dedicated case manager. Platinum ($349) provides comprehensive search reports, priority service, and cease & desist letter support."
  },
  {
    id: 5,
    question: "Do I need a trademark search before filing?",
    answer: "We strongly recommend a trademark search before filing. It identifies potential conflicts in USPTO records, state registrations, and common law usage\u2014saving you time and government fees if a conflict exists. Enhanced, Deluxe, and Platinum packages include thorough searches."
  },
  {
    id: 6,
    question: "Can you help with Amazon Brand Registry enrollment?",
    answer: "Yes. Our Amazon Brand Registry service guides you through the complete enrollment process. We ensure your trademark meets Amazon's requirements and help you unlock A+ Content, Sponsored Brands, and enhanced IP protection tools. This can be bundled with any trademark package."
  },
  {
    id: 7,
    question: "What happens if my application is rejected?",
    answer: "If the USPTO issues an office action, our team analyzes the objection, develops strong legal arguments, and submits a response within the required timeframe. Our Enhanced and higher packages include office action response support as part of the service."
  },
  {
    id: 8,
    question: "What's the difference between a trademark and copyright?",
    answer: "Trademarks protect brand identifiers\u2014names, logos, slogans\u2014that distinguish your goods or services. Copyrights protect original creative works like written content, images, and software. For Amazon sellers, trademarks are needed for Brand Registry while copyrights protect your listing content."
  },
  {
    id: 9,
    question: "Do I need an LLC before registering a trademark?",
    answer: "No, you can file as an individual. However, forming an LLC provides liability protection and professional credibility. For Amazon sellers planning to scale, we recommend company formation before trademark filing to align ownership with your Seller Central account."
  },
  {
    id: 10,
    question: "What are the USPTO filing fees?",
    answer: "USPTO filing fees range from $250\u2013$350 per trademark class and are paid directly to the government. These are separate from our service fees and are non-refundable. During your consultation, we identify the right classes and guide you through payment."
  }
];
